export default "__VITE_ASSET__KNC9F8kp__"